// extracted by mini-css-extract-plugin
module.exports = {"thumbprint":"style_thumbprint__fu52SZinxoGXeWKkU09x8"};